import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateConcesioneForm } from '../Validations/ValidationsConcesione';

export default function EditConcesionForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '', lugareId: '', tipoId: '', fecha: '', observaciones: '',
        terceroId: '', sepulturaId: '', serie: '', numero: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchConcesion = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/concesiones/${id}`);
                setFormData(response.data);
            } catch {
                setError('Error al cargar los datos de la concesión.');
            } finally {
                setIsLoading(false);
            }
        };
        if (id) fetchConcesion();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = await validateConcesioneForm(formData);
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.put(`/concesiones/${id}`, formData);
                navigate('/home/concesiones');
            } catch {
                setError('Error al actualizar la concesión.');
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-4xl mx-auto mt-8 bg-blue-50 p-6 rounded-lg shadow-lg">
            <h2 className="text-3xl font-bold mb-6 text-blue-700">Editar Concesión</h2>
            <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
                <div className="col-span-2">
                    <label className="block mb-1 font-semibold">ID</label>
                    <input type="text" name="id" value={formData.id} readOnly className="w-full p-2 border rounded bg-gray-200" />
                </div>
                {[
                    { name: 'lugareId', label: 'Lugar ID' },
                    { name: 'tipoId', label: 'Tipo ID' },
                    { name: 'fecha', label: 'Fecha', type: 'date' },
                    { name: 'terceroId', label: 'Tercero ID' },
                    { name: 'sepulturaId', label: 'Sepultura ID' },
                    { name: 'serie', label: 'Serie' },
                    { name: 'numero', label: 'Número' }
                ].map(({ name, label, type = 'text' }) => (
                    <div key={name}>
                        <label className="block mb-1 font-semibold">{label}</label>
                        <input type={type} name={name} value={formData[name]} onChange={handleChange} 
                            className={`w-full p-2 border rounded ${errors[name] ? 'border-red-500' : ''}`} required />
                        {errors[name] && <p className="text-red-500 text-xs italic">{errors[name]}</p>}
                    </div>
                ))}
                <div className="col-span-2">
                    <label className="block mb-1 font-semibold">Observaciones</label>
                    <textarea name="observaciones" value={formData.observaciones} onChange={handleChange} 
                        className={`w-full p-2 border rounded ${errors.observaciones ? 'border-red-500' : ''}`} required />
                    {errors.observaciones && <p className="text-red-500 text-xs italic">{errors.observaciones}</p>}
                </div>
                <div className="col-span-2">
                    <button type="submit" className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700">
                        {isLoading ? 'Actualizando...' : 'Actualizar Concesión'}
                    </button>
                </div>
            </form>
        </div>
    );
}

/*
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateConcesioneForm } from '../Validations/ValidationsConcesione'; // Asegúrate de crear esta validación

export default function EditConcesionForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        lugareId: '',
        tipoId: '',
        fecha: '',
        observaciones: '',
        terceroId: '',
        sepulturaId: '',
        serie: '',
        numero: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchConcesion = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/concesiones/${id}`);
                setFormData({
                    id: response.data.id || '',
                    lugareId: response.data.lugareId || '',
                    tipoId: response.data.tipoId || '',
                    fecha: response.data.fecha || '',
                    observaciones: response.data.observaciones || '',
                    terceroId: response.data.terceroId || '',
                    sepulturaId: response.data.sepulturaId || '',
                    serie: response.data.serie || '',
                    numero: response.data.numero || ''
                });
            } catch (err) {
                setError('Error al cargar los datos de la concesión.');
            } finally {
                setIsLoading(false);
            }
        };

        if (id) fetchConcesion();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Formulario enviado con datos:', formData); // Log para depurar
        const validationErrors = await validateConcesioneForm(formData);
        console.log('Errores de validación:', validationErrors); // Log de validación
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            setError(null);
            try {
                console.log('Actualizando datos en el servidor...');
                await axios.put(`/concesiones/${id}`, formData);
                console.log('Actualización exitosa.');
                navigate('/home/concesiones'); // Redirigir al listado después de guardar
            } catch (err) {
                setError('Error al actualizar la concesión. Por favor, intente de nuevo.');
                console.error('Error updating concesión:', err);
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors); // Mostrar errores si la validación falla
        }
    };

    if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-2xl mx-auto mt-8">
            <h2 className="text-2xl font-bold mb-4">Editar Concesión</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block mb-1">ID</label>
                    <input
                        type="text"
                        name="id"
                        value={formData.id}
                        className="w-full p-2 border rounded"
                        required
                        readOnly
                    />
                </div>
                <div>
                    <label className="block mb-1">Lugar ID</label>
                    <input
                        type="text"
                        name="lugareId"
                        value={formData.lugareId}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.lugareId ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.lugareId && <p className="text-red-500 text-xs italic">{errors.lugareId}</p>}
                </div>
                <div>
                    <label className="block mb-1">Tipo ID</label>
                    <input
                        type="text"
                        name="tipoId"
                        value={formData.tipoId}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.tipoId ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.tipoId && <p className="text-red-500 text-xs italic">{errors.tipoId}</p>}
                </div>
                <div>
                    <label className="block mb-1">Fecha</label>
                    <input
                        type="date"
                        name="fecha"
                        value={formData.fecha}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.fecha ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
                </div>
                <div>
                    <label className="block mb-1">Observaciones</label>
                    <textarea
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.observaciones ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.observaciones && <p className="text-red-500 text-xs italic">{errors.observaciones}</p>}
                </div>
                <div>
                    <label className="block mb-1">Tercero ID</label>
                    <input
                        type="text"
                        name="terceroId"
                        value={formData.terceroId}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.terceroId ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.terceroId && <p className="text-red-500 text-xs italic">{errors.terceroId}</p>}
                </div>
                <div>
                    <label className="block mb-1">Sepultura ID</label>
                    <input
                        type="text"
                        name="sepulturaId"
                        value={formData.sepulturaId}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.sepulturaId ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.sepulturaId && <p className="text-red-500 text-xs italic">{errors.sepulturaId}</p>}
                </div>
                <div>
                    <label className="block mb-1">Serie</label>
                    <input
                        type="text"
                        name="serie"
                        value={formData.serie}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.serie ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.serie && <p className="text-red-500 text-xs italic">{errors.serie}</p>}
                </div>
                <div>
                    <label className="block mb-1">Número</label>
                    <input
                        type="text"
                        name="numero"
                        value={formData.numero}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.numero ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.numero && <p className="text-red-500 text-xs italic">{errors.numero}</p>}
                </div>
                <button
                    type="submit"
                    className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
                    disabled={isLoading}
                >
                    {isLoading ? 'Actualizando...' : 'Actualizar Concesión'}
                </button>
            </form>
        </div>
    );
}
*/